import { IContact } from '@ViewModels';
import { css } from 'aphrodite';
import { getDisplayName } from '../../../../models/NameUtils';
import { Button } from '../../../components-v2/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../Tooltip';
import { InfoIcon } from '../../svgs/icons/InfoIcon';
import { styleSheet } from './styles';

interface IHouseholdRecipientsInfoProps {
	members: IContact[];
}

export function HouseholdRecipientsInfo({ members }: IHouseholdRecipientsInfoProps) {
	if (!members?.length) {
		return null;
	}

	return (
		<TooltipProvider>
			<Tooltip>
				<TooltipTrigger asChild>
					<Button
						aria-label='Household information'
						onClick={ev => ev.stopPropagation()}
						size='icon'
						type='button'
						variant='ghost'
					>
						<InfoIcon />
					</Button>
				</TooltipTrigger>
				<TooltipContent align='start' side='bottom' styles={[styleSheet.tooltipContent]}>
					<div className={css(styleSheet.tooltipHeader)}>Household Information</div>
					{members.map(member => {
						const primaryEmail = member.emailAddresses?.[0]?.value;
						return (
							<div className={css(styleSheet.memberCard)} key={member.id}>
								<div className={css(styleSheet.memberName)}>{getDisplayName(member)}</div>
								<div className={css(primaryEmail ? styleSheet.memberEmail : styleSheet.memberEmailMissing)}>
									{primaryEmail || 'No email address'}
								</div>
							</div>
						);
					})}
				</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	);
}
